import * as React from 'react';

interface NoSsrProps {
  children?: React.ReactNode;
  defer?: boolean;
  fallback?: React.ReactNode;
}

export default function NoSsr(props: NoSsrProps) {
  const { children, defer = true, fallback = null } = props;

  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    if (!defer) {
      setMounted(true);
      return;
    }

    const id = requestAnimationFrame(() => {
      setMounted(true);
    });

    return () => {
      cancelAnimationFrame(id);
    };
  }, [defer]);

  if (!mounted) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
